import styled from 'styled-components'

export const Inner = styled.div`
  min-height: 100vh;
`
